// test2306
(2306 && 0);
